import React, {useRef} from "react"

import FormToggle from "../../../../../../gd-form/form-element/toggle-new/toggle"
import LexicalEditorLocalSettings from "../../../../settings/local-settings"
import {LexicalEditor} from "lexical"

type Props = {
    menuParams  : {
        editor              : LexicalEditor
        localSettings       : LexicalEditorLocalSettings
        hideControlsAllowed : boolean
    }
    hidePopover : callback
}

const debug = false
// const debug = "ToolbarMoreMenu"

export default function ToolbarMoreMenu(props:Props) {

    const togglePinRef      = useRef<FormToggle>(null)
    const toggleAutolinkRef = useRef<FormToggle>(null)
    const toggleControlsRef = useRef<FormToggle>(null)

    const onTogglePinToolbar = () => {
        debug && console.log(debug, 'onTogglePinToolbar')

        // props.hidePopover()
        props.menuParams.localSettings.pinToolBar = !props.menuParams.localSettings.pinToolBar
        props.menuParams.localSettings.save()

        gd.bus.triggerEvent('lexical-update-editor')
    }

    const onToggleAutolink = (value: boolean) => {
        debug && console.log(debug, 'onToggleAutolink', value)

        // props.hidePopover()
        props.menuParams.localSettings.autolink = !props.menuParams.localSettings.autolink
        props.menuParams.localSettings.save()

        gd.bus.triggerEvent('lexical-update-editor')
    }

    const onToggleShowControlsToolbar = (value: boolean) => {
        debug && console.log(debug, 'onToggleAutolink', value)

        // props.hidePopover()
        props.menuParams.localSettings.showControls = !props.menuParams.localSettings.showControls
        props.menuParams.localSettings.save()

        gd.bus.triggerEvent('lexical-update-editor')
    }

    return (
        <div className="ui5-popover-menu icon-fs-16" style={{minWidth: 200}}>
            <div className="option" onClick={() => {
                togglePinRef?.current?.onClick()
            }}>
                <FormToggle ref={togglePinRef}
                            className="m-r-5"
                            size="14"
                            value={props.menuParams.localSettings.pinToolBar}
                            onChange={onTogglePinToolbar}/>
                <div className="label">Pin toolbar</div>
            </div>

            <div className="option" onClick={() => {
                toggleAutolinkRef?.current?.onClick()
            }}>
                <FormToggle ref={toggleAutolinkRef}
                            className="m-r-5"
                            size="14"
                            value={props.menuParams.localSettings.autolink}
                            onChange={onToggleAutolink}/>
                <div className="label">On/Off Autolink</div>
            </div>

            {props.menuParams.hideControlsAllowed &&
                <div className="option" onClick={() => {
                    toggleControlsRef?.current?.onClick()
                }}>
                    <FormToggle ref={toggleControlsRef}
                                className="m-r-5"
                                size="14"
                                value={props.menuParams.localSettings.showControls}
                                onChange={onToggleShowControlsToolbar}/>
                    <div className="label">Show controls</div>
                </div>}

        </div>
    )
}